import { api } from '@/core/api/';
const apiUrl = 'api/medicaidclaim';

export const getStatuses = () => api.get(`${apiUrl}/statuses`);
export const getByServices = (params) =>
  api.get(`${apiUrl}/services`, { params });
export const getByStudents = (params) =>
  api.get(`${apiUrl}/students`, { params });
export const getByServiceLocation = (params) =>
  api.get(`${apiUrl}/service-location`, { params });
export const getLog = (id) => api.get(`${apiUrl}/${id}/log`);
export const validateService = (academicYearId) =>
  api.get(`${apiUrl}/validate-service/${academicYearId}`);

export const getBatchStatuses = () => api.get(`${apiUrl}/batch-statuses`);
export const getBatches = (params) => api.get(`${apiUrl}/batch`, { params });
export const createBatch = (payload) => api.post(`${apiUrl}/batch`, payload);
export const getBatch = (id) => api.get(`${apiUrl}/batch/${id}`);
export const getBatchServices = (id, params) =>
  api.get(`${apiUrl}/batch/${id}/services`, { params });
export const changeBatchStatus = (id, payload) =>
  api.patch(`${apiUrl}/batch/${id}/change-status`, payload);
export const getBatchLog = (id) => api.get(`${apiUrl}/batch/${id}/log`);
export const existsDraftBatchForLocations = (payload) =>
  api.post(`${apiUrl}/batch-validate-locations`, payload);
export const getBatchDetailLog = (id, detailId, params) =>
  api.get(`${apiUrl}/batch/${id}/services/${detailId}/log`, { params });
